import React, { useEffect, useState } from 'react';
import './Navbar.css';
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import CartModal from '../../../Modal/CartModal';
import { useSelector } from 'react-redux';

export const Navbar = ({ orgInfo }) => {
  console.log("org Info:", orgInfo);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false); // State for CartModal
  const navigate = useNavigate();
  const location = useLocation();
  const { orgcode } = useParams();

  const cartItems = useSelector((state) => state.cart?.items || []); // Fallback to empty array if state.cart is undefined
  const cartItemCount = cartItems.reduce((count, item) => count + item.quantity, 0);

  // Check if OMS is enabled
  const hasOMS = orgInfo?.organization?.hasOMS || false;

  // Debugging log
  console.log("hasOMS:", hasOMS);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const toggleCart = () => {
    setIsCartOpen(!isCartOpen);
  };

  useEffect(() => {
    // Close menu when clicking outside
    const handleOutsideClick = (event) => {
      if (!event.target.closest(".navbar-theme-six")) {
        closeMenu();
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  return (
    <>
      <div
        className="d-flex w-100 align-items-center text-black position-fixed top-0 left-0 navbar-theme-nine"
      >
        {/* Brand */}
        <div className='d-flex container ps-0' onClick={() => navigate(`/${orgcode}`)}>
          {orgInfo?.organization?.cloudR2ImagePath && (
            <img
              className='theme-nine-logo'
              src={orgInfo?.organization?.cloudR2ImagePath?.getCDNUrl()}
              alt="Organization Logo"
            />
          )}
          <p className="m-0 fs-4 text-black pt-2">{orgInfo?.organization?.name}</p>
        </div>

        {/* Navigation */}
        <div className='p-0 m-0 gap-2 d-flex align-items-center justify-content-center'>
          <ul
            className={`theme-nine-ul d-flex align-items-center list-unstyled m-0 ${
              menuOpen ? '' : 'd-none d-lg-flex'
            }`}
          >
            <li><Link to={`/${orgcode}`} className='text-decoration-none fs-5 text-black'>Home</Link></li>
            <li><Link to={`/${orgcode}/about`} className='text-decoration-none fs-5 text-black'>About</Link></li>
            <li><Link to={`/${orgcode}/food-menu`} className='text-decoration-none fs-5 text-black'>Menu</Link></li>
            <li><Link to={`/${orgcode}/contact`} className='text-decoration-none fs-5 text-black'>Contact</Link></li>
          </ul>

          {/* Cart Icon and Badge (Conditional Rendering) */}
          {hasOMS && (
            <div className="d-flex align-items-center">
              <i className="ri-shopping-cart-line fs-5" onClick={toggleCart}></i>
              {cartItemCount > 0 && (
                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                  {cartItemCount}
                </span>
              )}
            </div>
          )}

          {/* Toggle Menu */}
          <li
            className={`d-lg-none theme-nine-li cursor-pointer ${menuOpen ? 'open' : ''}`}
            onClick={(e) => {
              e.stopPropagation(); // Prevent the menu from closing when clicking the toggle button
              toggleMenu();
            }}
          >
            <span></span>
            <span></span>
            <span></span>
          </li>
        </div>
      </div>
      <CartModal isOpen={isCartOpen} toggle={toggleCart} orgInfo={orgInfo} />
    </>
  );
};